import React, { FC } from 'react';
import _ from 'lodash';
import { Box } from '@wix/design-system';
import { UserDetails, VIEW_MODE } from '@common/types';
import { wixStudioToolBarDataHooks } from './WixStudioToolBar.dataHooks';
import { Platform } from '@wix/ambassador-wixstudio-templates-v1-template/types';

import Switcher from './Switcher';
import PurchaseTemplateButton from '@components/Template/PurchaseTemplateButton';
import SimpleHeader from '@components/SimpleHeader';
import { marketplacePath } from '@components/Hooks/useRouter';
import s from './WixStudioToolBar.module.scss';

interface Props {
  viewMode: VIEW_MODE;
  dataHook?: string;
  templateId?: string;
  price?: number;
  isMobileView: boolean;
  editorType: Platform;
  language: string;
  userDetails?: UserDetails;
  isListing?: boolean;
  toggleViewMode: (viewMode: VIEW_MODE) => any;
  logBiClick: (clickType: string) => void;
  setPurchaseError: (isError: boolean) => void;
  privacyPolicyUrl?: string;
  hasCustomCode: boolean;
}

export const WixStudioToolBar: FC<Props> = ({
  viewMode,
  dataHook,
  isMobileView,
  templateId,
  price,
  editorType,
  language,
  userDetails,
  isListing,
  toggleViewMode,
  logBiClick,
  setPurchaseError,
  privacyPolicyUrl,
  hasCustomCode,
}) => {
  return (
    <div
      data-hook={dataHook}
      className={isMobileView ? s.wixStudioToolBarMobile : s.wixStudioToolBar}
    >
      <SimpleHeader
        link={marketplacePath}
        isMobileView={isMobileView}
        platform={isListing ? undefined : editorType}
        className="viewTemplate"
      />
      {isMobileView ? null : (
        <div className={s.switcher} data-hook="switcher-wrapper">
          <Switcher
            editorType={editorType}
            viewMode={viewMode}
            toggleViewMode={toggleViewMode}
            dataHook={wixStudioToolBarDataHooks.deviceSwitcher}
          />
        </div>
      )}
      {!_.isUndefined(price) && (
        <Box>
          <PurchaseTemplateButton
            showShortFreeCta={isMobileView}
            logBiClick={() => logBiClick('view template - purchase')}
            price={price}
            templateId={templateId!}
            buttonSize={isMobileView ? 'small' : 'medium'}
            language={language}
            userDetails={userDetails}
            setPurchaseError={setPurchaseError}
            consentModalProps={{
              hasCustomCode,
              onModalBiClick: logBiClick,
              isMobileView,
            }}
            hasShortCTA={isMobileView}
            privacyPolicyUrl={privacyPolicyUrl}
          />
        </Box>
      )}
    </div>
  );
};

export default WixStudioToolBar;
